var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "director__missing-info" },
    [
      _c(
        "v-popover",
        {
          ref: "popover",
          staticClass: "d-inline",
          attrs: {
            "popover-class": "director__missing-info__popover",
            trigger: "hover click",
            placement: "auto",
            offset: 10
          }
        },
        [
          _c(
            "button",
            {
              staticClass: "director__missing-info__indicator vs-btn-legacy",
              on: {
                touchstart: _vm.$_openPopover,
                mousedown: _vm.$_handleClick
              }
            },
            [
              _c("i", {
                staticClass: "fa fa-info-circle",
                attrs: { "aria-hidden": "true" }
              })
            ]
          ),
          _vm._v(" "),
          _c("template", { slot: "popover" }, [
            _c(
              "div",
              { staticClass: "text-left", on: { click: _vm.$_handleClick } },
              [_vm._v("\n        " + _vm._s(_vm.$_popover_text) + "\n      ")]
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }